import React from 'react';
import './list-rich-text.scss';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const ListRichText = props => {
    const { info } = props;
    return (
        <div className="a-list-rich-text">
            {documentToReactComponents(JSON.parse(info))}
        </div>
    )
}

export default ListRichText;
